import { render, staticRenderFns } from "./ConfirmationPopupInner.vue?vue&type=template&id=28b5052e&"
import script from "./ConfirmationPopupInner.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPopupInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports